import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // Using a light blue background for the banner look
    backgroundColor: '#e1e8f0',
    color: '#0d47a1',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center', // Centers content horizontally
    alignItems: 'center',
    borderBottom: '1px solid #bbdefb',
    // This creates a soft, internal vignette effect using a transparent dark blue
    boxShadow: 'inset 0 0 15px rgba(13, 71, 161, 0.4)',
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center', // Aligns icon and text vertically
    maxWidth: '960px', // Prevents content from stretching too wide
    width: '100%',
  },
  icon: {
    fontSize: '3rem', // Large icon/emoji
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    color: '#1E2864',
  },
  header: {
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  lineText: {
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  footerText: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}))

const ExpirationBanner = () => {
  const classes = useStyles()
  const [isVisible, setIsVisible] = useState(false)
  const { t } = useTranslation('expirationBanner')

  // Data Definition
  const bannerData = {
    emoji: '🎄', // You can swap this for an SVG Icon component if preferred
    header: t('header'),
    line1: t('line1'),
    line2: t('line2'),

    // ISO Format: YYYY-MM-DDTHH:MM:SS
    visibleFrom: '2025-12-24T00:00:00',
    visibleUntil: '2026-01-05T00:00:00',
  }

  // Check if "Now" is inside the Window
  useEffect(() => {
    const checkVisibility = () => {
      const now = new Date()
      const startDate = new Date(bannerData.visibleFrom)
      const endDate = new Date(bannerData.visibleUntil)

      // Condition: Now is AFTER start AND BEFORE end
      const isWindowOpen = now >= startDate && now < endDate

      setIsVisible(isWindowOpen)
    }

    checkVisibility()
  }, [bannerData.visibleFrom, bannerData.visibleUntil])

  // If validation fails or date is passed, render nothing
  if (!isVisible) return null

  return (
    <Paper elevation={0} square className={classes.root}>
      <Box className={classes.contentContainer}>
        {/* Left Icon/Emoji */}
        <div className={classes.icon} role="img" aria-label="icon">
          {bannerData.emoji}
        </div>

        {/* Text Stack */}
        <div className={classes.textContainer}>
          <Typography variant="subtitle1" className={classes.header}>
            {bannerData.header}
          </Typography>
          <Typography variant="body2" className={classes.lineText}>
            {bannerData.line1}
          </Typography>
          <Typography variant="body2" className={classes.footerText}>
            {bannerData.line2}
          </Typography>
        </div>
      </Box>
    </Paper>
  )
}

export default ExpirationBanner
export { ExpirationBanner }
